/* eslint-disable @typescript-eslint/no-use-before-define */

import React, { useEffect } from 'react';
import MaskedInputBase from 'react-text-mask';

import NumberFormat from 'react-number-format';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

interface MaskedInputProps {
  inputRef: (ref: HTMLInputElement | null) => void;
}

interface NumberFormatCustomProps {
  inputRef: (instance: NumberFormat<any> | null) => void;
  onChange: (event: { target: { name: string; value: string } }) => void;
  value: string;
  name: string;
  decimalSeparator?: string;
}

const MaskedInputCNPJ: React.FunctionComponent<MaskedInputProps> = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInputBase
      {...other}
      guide
      mask={[
        /[0-9]/,
        /[0-9]/,
        '.',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '.',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '/',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '-',
        /[0-9]/,
        /[0-9]/,
      ]}
      ref={(ref: any) => {
        inputRef(ref ? ref.inputElement : null);
      }}
    />
  );
};

const MaskedInputDate: React.FunctionComponent<MaskedInputProps> = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInputBase
      {...other}
      guide
      mask={[
        /[0-9]/,
        /[0-9]/,
        '/',
        /[0-9]/,
        /[0-9]/,
        '/',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
      ]}
      ref={(ref: any) => {
        inputRef(ref ? ref.inputElement : null);
      }}
    />
  );
};

const MaskedInputCurrencyOld: React.FunctionComponent<NumberFormatCustomProps> = (
  props,
) => {
  const { inputRef, onChange, name, ...other } = props;

  return (
    <NumberFormat
      {...other}
      allowNegative={false}
      decimalScale={2}
      decimalSeparator=','
      fixedDecimalScale
      getInputRef={inputRef}
      isNumericString
      onValueChange={(values) => {
        onChange({
          target: {
            name,
            value: values.value,
          },
        });
      }}
      prefix='R$ '
      thousandSeparator='.'
    />
  );
};

const MaskedInputCurrency: React.FunctionComponent<NumberFormatCustomProps> = (
  props,
) => {
  const [internalValue, setInternalValue] = React.useState('0');
  const { inputRef, onChange, name, value, ...other } = props;
  const currencyFormatter = (value: string) => {
    const amount = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(Number(value) / 100);

    return `${amount}`;
  };
  useEffect(() => {
    if (value !== 'null' && value !== null && value !== undefined) {
      setInternalValue(String(Number(value) * 100));
    }
  }, [value]);

  return (
    <NumberFormat
      {...other}
      format={currencyFormatter as any}
      value={internalValue || '0'}
      placeholder='R$ 0,00'
      allowNegative={false}
      decimalSeparator=','
      getInputRef={inputRef}
      isNumericString
      fixedDecimalScale
      decimalScale={2}
      datatype='number'
      translate='yes'
      onValueChange={(values) => {
        if (values.value !== null) {
          setInternalValue(values.value);
          onChange({
            target: {
              name,
              value: String(Number(values.value) / 100),
            },
          });
        }
      }}
      prefix='R$ '
      thousandSeparator='.'
    />
  );
};

const MaskedInputPercent: React.FunctionComponent<MaskedInputProps> = (
  props,
) => {
  const { inputRef, ...other } = props;
  return (
    <MaskedInputBase
      {...other}
      mask={createNumberMask({
        prefix: '',
        suffix: '%',
        decimalSymbol: '.',
        decimalSeparator: '.',
        decimalScale: 2,
        allowDecimal: true,
        requireDecimal: false,
        // thousandsSeparatorSymbol: '.',
        integerLimit: 3,
        maxValue: 100,
        minValue: 0,
      })}
      ref={(ref: any) => {
        inputRef(ref ? ref.inputElement : null);
      }}
    />
  );
};

const MaskedInputCEP: React.FunctionComponent<MaskedInputProps> = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInputBase
      {...other}
      guide
      mask={[
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '-',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
      ]}
      ref={(ref: any) => {
        inputRef(ref ? ref.inputElement : null);
      }}
    />
  );
};

const MaskedInputPhone: React.FunctionComponent<MaskedInputProps> = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInputBase
      {...other}
      guide
      mask={[
        '(',
        /[0-9]/,
        /[0-9]/,
        ')',
        ' ',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '-',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
      ]}
      ref={(ref: any) => {
        inputRef(ref ? ref.inputElement : null);
      }}
    />
  );
};

const MaskedInputElevation: React.FunctionComponent<MaskedInputProps> = (
  props,
) => {
  const { inputRef, ...other } = props;
  return (
    <MaskedInputBase
      {...other}
      mask={createNumberMask({
        prefix: '',
        suffix: 'ª',
        decimalSymbol: ',',
        allowDecimal: false,
        requireDecimal: false,
        // thousandsSeparatorSymbol: '.',
        integerLimit: 3,
        maxValue: 100,
        minValue: 0,
      })}
      ref={(ref: any) => {
        inputRef(ref ? ref.inputElement : null);
      }}
    />
  );
};

export {
  MaskedInputCNPJ,
  MaskedInputDate,
  MaskedInputCurrency,
  MaskedInputPercent,
  MaskedInputCEP,
  MaskedInputPhone,
  MaskedInputElevation,
  MaskedInputCurrencyOld,
};
